import React, { Component } from 'react';

import { reduxForm } from 'redux-form';
import FieldItems from 'components/shared/FieldItems/FieldItems';

import RoomCard from './RoomCard/RoomCard';
import { SavedRooms } from './SavedRooms';

class PropertyRooms extends Component {
  render() {
    const { handleSubmit } = this.props;

    return (
      <div className="row" style={{ marginBottom: '25px' }}>
        <div>
          <h3 style={{ textAlign: 'center', margin: '25px 0px 30px 0px' }}>Room(s)</h3>
          <p style={{ textAlign: 'center', marginBottom: '15px' }}>
            Rooms associated to the building and not associated to any units.
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          <FieldItems
            name="rooms"
            formName={this.props.form}
            renderSavedItems={SavedRooms}
            renderForm={RoomCard}
            dialogHeader="Add Room"
            formProps={{ skipNodes: 0 }}
            buttonVerbiageOverride="Add Room"
          />
        </form>

        <div id="button" style={{ marginBottom: '75px' }} />
      </div>
    );
  }
}

PropertyRooms = reduxForm({
  form: 'add_property',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true,
})(PropertyRooms);

export default PropertyRooms;
